<template>
  <v-container class="py-16" :style="componentStyle" :id="sectionId">
    <v-row>
      <v-col cols="12" class="d-flex justify-center">
          <vue-plyr
            v-if="videoUrl"
            class="video-player "
          >
            <iframe
              v-if="iframe"
              :src="videoUrl"
              frameborder="0"
              webkitallowfullscreen
              mozallowfullscreen
              allowfullscreen
              style="width: 100%;"
              width="640"
              height="360"
            >
            </iframe>
            <video
              v-else
              controls
              type="video/mp4"
              ref="video"
              :poster="videoPosterUrl"
            >
              <source :src="videoUrl" />
            </video>
          </vue-plyr>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import promotionPageMixin from '../mixins/promotion-page'
export default {
  mixins: [promotionPageMixin],
  computed: {
    iframe () {
      return this.videoUrl && (this.videoUrl.toLowerCase().includes('vimeo') || this.videoUrl.toLowerCase().includes('youtube'))
    }
  },
  props: {
    videoUrl: {
      type: String
    },
    videoPosterUrl: {
      type: String
    },
    videoCurrentTime: {
      type: Number,
      default: 0
    }
  }
}
</script>
<style scoped lang="scss">

video {
  height: auto;
  width: 100%;

  &:focus {
    outline: none;
  }
}

</style>

<style scoped>
.video-player{
  width: 100%;
  max-width: 640px;
}
.video-player .plyr--video .plyr__controls {
  background: rgba(69, 71, 73, 0.5) !important;
  height: 45px;
  padding: 0 10px 0 10px !important;
}
.video-player .plyr__control--overlaid {
  background: rgba(69, 71, 73, 0.5) !important;
}
.video-player .plyr--full-ui input[type="range"] {
  color: rgba(125, 197, 201, 0.81) !important;
}

.plyr--video .plyr__control.plyr__tab-focus,
.plyr--video .plyr__control:hover,
.plyr--video .plyr__control[aria-expanded="true"] {
  background: rgba(125, 197, 201, 0.81) !important;
}
</style>
